var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { getAll as getAllApi } from '../../api/invoice';
import { useInvoiceColumns } from '../../hooks/useColumns';
import { useRequest } from '../../hooks/requestHook';
import useFetch from '../../hooks/useFetch';
import MaterialTable from '../MaterialTable';
import { decamelize } from '../../utils/camelize';
import Select from '../atoms/SelectField';
import PageLayout from '../atoms/PageLayout';
import { Box } from '@mui/material';
import i18n from '../../i18n';
import { convertLanguage } from '../../utils/languageUtils';
var PaidSelect = function (_a) {
    var columnDef = _a.columnDef, onFilterChanged = _a.onFilterChanged, label = _a.label;
    var handleChange = React.useCallback(function (event) {
        var value = event.target.value;
        onFilterChanged(columnDef.tableData.id, value);
    }, [columnDef, onFilterChanged]);
    return (React.createElement(Select, { fullWidth: true, margin: "none", variant: "standard", value: columnDef.tableData.filterValue || null, onChange: handleChange, label: label || '', items: [
            { text: 'All', value: '' },
            { text: 'Yes', value: 'paid' },
            { text: 'No', value: 'unpaid' },
        ] }));
};
var RoasterInvoicesPage = function () {
    var t = useTranslation().t;
    var location = useLocation();
    var InvoiceColumns = useInvoiceColumns();
    var getAll = useRequest(getAllApi);
    var tableRef = React.createRef();
    var urlQuery = qs.parse(location.search.slice(1));
    var initialPage = parseInt((urlQuery.page || '')) || 0;
    var pageSize = parseInt((urlQuery.pageSize || '')) || 25;
    var defaultFilter = React.useCallback(function (field) {
        var filters = urlQuery.filters || {};
        return filters[field];
    }, [urlQuery]);
    var renderPaidSelect = React.useCallback(function (props) { return React.createElement(PaidSelect, __assign({}, props)); }, []);
    var columns = React.useMemo(function () { return [
        __assign(__assign({}, InvoiceColumns.title), { filtering: true, defaultFilter: defaultFilter('title') }),
        __assign(__assign({}, InvoiceColumns.createdDate), { filtering: false }),
        __assign(__assign({}, InvoiceColumns.expiredDate), { filtering: false }),
        __assign(__assign({}, InvoiceColumns.total), { filtering: false }),
        __assign(__assign({}, InvoiceColumns.paid), { filtering: true, filterComponent: renderPaidSelect, defaultFilter: defaultFilter('paid') }),
    ]; }, [defaultFilter, renderPaidSelect, InvoiceColumns]);
    var buildFilterParams = React.useCallback(function (query) {
        var q = {};
        query.filters.forEach(function (filter) {
            switch (filter.column.field) {
                case 'paidAt':
                    if (filter.value)
                        q[filter.value] = true;
                    break;
                default:
                    if (filter.column.field) {
                        var field = filter.column.field
                            .split('.')
                            .map(function (e) { return decamelize(e); })
                            .join('_');
                        q["".concat(field, "_cont")] = filter.value;
                    }
                    break;
            }
        });
        return q;
    }, []);
    var fetchInvoices = useFetch({
        buildFilterParams: buildFilterParams,
        api: getAll,
    });
    var convertedLanguage = convertLanguage(i18n.language);
    return (React.createElement(PageLayout, { title: React.createElement(React.Fragment, null,
            React.createElement(Box, { component: "p", sx: {
                    color: 'red',
                    fontSize: '0.9rem',
                    lineHeight: '1.5',
                    fontWeight: 'normal',
                } },
                React.createElement(Trans, { i18nKey: "messages.newPlatformInvoiceNotice" },
                    React.createElement("a", { href: "https://typica.coffee/".concat(convertedLanguage, "/my/invoices"), target: "_blank", rel: "noopener noreferrer", style: { color: 'red' } }))),
            React.createElement(Box, { component: "h4", sx: { typography: function (theme) { return theme.customTypography.h4; } } }, t('invoices'))) },
        React.createElement(MaterialTable, { tableRef: tableRef, model: "invoice", columns: columns, data: fetchInvoices, detailPath: function (invoice) { return "/roaster/invoices/".concat(invoice.id); }, options: {
                filtering: true,
                filterCellStyle: {
                    minWidth: 100,
                    maxWidth: 200,
                },
                paging: true,
                initialPage: initialPage,
                pageSize: pageSize,
            } })));
};
export default RoasterInvoicesPage;
